import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {
            appcode:'',
            responsetemplate:'',
            requesttemplate:'',
            authcode:'',
            servicedesc:''
        }, //根据id查询的数据详情信息
        searchP:{
            appcode:'',//模块编码
            domain:'',//领域
            authflag:'',//授权标识
            activekey:'1',
            routeflag:'',
            serviceflag:'',
            encryptflag:''
        },
    },
    getters: {
    },
    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {
        //查询list列表
        select(context, payload) {
            payload.type = 'servicekey/select'
            // console.log(payload, "payload----------")
            return D.select(payload)
        },
        //服务级别
        jibie(context, payload) {
            payload.type = 'servicekey/jibie'
            return D.select(payload)
        },
        //日志级别
        rizhi(context, payload) {
            payload.type = 'servicekey/rizhi'
            return D.select(payload).then(response => {
                let { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data || [],
                    }
                })
            })
        },
        //新增
        add(context, payload) {
            return D.add(payload)
        },
        //修改
        edit(context, payload) {
            return D.edit(payload)
        },
        //保存批量修改
        batupdate(context, payload) {
            return D.edit(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'jibie' })
                return response
            })
        },
        //保存批量修改
        batsetting(context, payload) {
            return D.edit(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'jibie' })
                return response
            })
        },
        //日志级别修改
        rizhiupdate(context, payload) {
            return D.edit(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'rizhi' })
                return response
            })
        },
        //删除
        del(context, payload) {
            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'select' })
                return response
            })
        },
        //详情
        detail(context, payload) {
            return D.detail(payload).then(response => {
                let { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        record: data ? data : {appcode:''}
                    }
                })
                return response
            })
        },
        getAuthedAppList(context, payload){
            return D.select({
                ...payload
            })
        },
        getAppList(context, payload){
            return D.select({
                ...payload
            })
        },
        addOrUpdateApp(context, payload){
            return D.edit({
                ...payload
            })
        },
        deleteAuthedApp(context, payload){
            return D.del({
                ...payload
            })
        },
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        appcode:'',//模块编码
                        domain:'',//领域
                        authflag:'',//授权标识
                        routeflag:'',//路由领域
                        encryptflag:'',
                        serviceflag:''
                    }
                }
            })
        },
        //导出
        exportService(context, payload) {
            return D.add(payload)
        },
        //查询导出状态
        checkExportStatue(context, payload) {
            return D.add(payload)
        },

        //导入配置
        importService(context, payload) {
            return D.add(payload)
        },
        //导入记录
        saveImportService(context, payload) {
            return D.add(payload)
        },
        //查询导出状态
        checkImportStatue(context, payload) {
            return D.add(payload)
        },
        //风控配置列表
        queryriskconfig(context, payload){
            return D.select({
                ...payload
            })
        },
        //风控配置列表-删除
        deleteriskconfig(context, payload){
            return D.del({
                ...payload
            })
        },
        //风控配置列表-详情
        detailriskconfig(context, payload){
            return D.select({
                ...payload
            })
        },
        //风控配置列表-更新
        updateriskconfig(context, payload){
            return D.edit({
                ...payload
            })
        },
        //风控配置列表-详情2
        queryriskconfiglist(context, payload){
            return D.select({
                ...payload
            })
        },



        //风控配置列表
        queryAppriskconfig(context, payload){
            return D.select({
                ...payload
            })
        },
        //风控配置列表-删除
        deleteAppriskconfig(context, payload){
            return D.del({
                ...payload
            })
        },
        //风控配置列表-详情
        detailAppriskconfig(context, payload){
            return D.select({
                ...payload
            })
        },
        //风控配置列表-更新
        updateAppriskconfig(context, payload){
            return D.edit({
                ...payload
            })
        },
        //风控配置列表-详情2
        queryAppriskconfiglist(context, payload){
            return D.select({
                ...payload
            })
        },

        queryunauthedservice(context, payload){
            return D.select({
                ...payload
            })
        },

        compare(context, payload){
            return D.select({
                ...payload
            })
        },
        cover(context, payload){
            return D.edit({
                ...payload
            })
        },
        coverP(context, payload){
            return D.select({
                ...payload
            })
        },
        coverAll(context, payload){
            return D.edit({
                ...payload
            })
        },


        //处理器配置
        processorAddClass(context, payload){
            return D.add({
                ...payload
            })
        },

        processorDelClass(context, payload){
            return D.del({
                ...payload
            })
        },

        processorEditClass(context, payload){
            return D.edit({
                ...payload
            })
        },

        processorQueryClass(context, payload){
            return D.select({
                ...payload
            })
        },

        processorQueryClassListPage(context, payload){
            return D.select({
                ...payload
            })
        },

        processorRefreshClass(context, payload){
            return D.select({
                ...payload
            })
        },

        //处理器映射配置
        processorAdd(context, payload){
            return D.add({
                ...payload
            })
        },

        processorDel(context, payload){
            return D.del({
                ...payload
            })
        },

        processorEdit(context, payload){
            return D.edit({
                ...payload
            })
        },

        processorQuery(context, payload){
            return D.select({
                ...payload
            })
        },

        processorQueryListPage(context, payload){
            return D.select({
                ...payload
            })
        },

        processorRefresh(context, payload){
            return D.select({
                ...payload
            })
        },

        processorActive(context, payload){
            return D.del({
                ...payload
            })
        },
        
    }
}
